const defaultSlotList = [
  {
    slotName: 'index', // 槽名
  },
  {
    slotName: 'status',
    type: 'boolean', // 类型：'boolean' - text字段有无、(true/false)
    name1: '正常', // text字段有或true 展示
    name2: '作废', // text字段无或false 展示
  },
  {
    slotName: 'bool',
    type: 'boolean', // 类型：'boolean' - text字段有无、(true/false)
    name1: '是', // text字段有或true 展示
    name2: '否', // text字段无或false 展示
  },
  {
    slotName: 'is_active',
    type: 'boolean', // 类型：'boolean' - text字段有无、(true/false)
    name1: '可用', // text字段有或true 展示
    name2: '作废', // text字段无或false 展示
  },
  {
    slotName: 'time',
    type: 'time', // 类型：'time' - text字段为时间
  },
  {
    slotName: 'datetime',
    type: 'datetime', // 类型：'datetime' - text字段为日期 时间
  },
  {
    slotName: 'date',
    type: 'date', // 类型：'date' - text字段为日期
  },
  {
    slotName: 'group',
    type: 'list', // 类型：'list' - text字段为数组
  },
];
export default defaultSlotList;
